'use client';

import styles from './index.module.scss';
import AnimatedHeadings from '@components/AnimatedHeadings';
import AnimatedParagraphs from '@components/AnimatedParagraphs';
import { Card, CardDescription, CardHeader } from '@components/ui/card';
import { Montserrat } from 'next/font/google';
import { motion } from 'framer-motion';
import { useProcessOverview } from './useProcessOverview';

const montserrat = Montserrat({ subsets: ['latin'] });

const ProcessOverview = () => {
  const {
    t,
    isEven,
    activeIndex,
    handleClick,
    containerRef,
    processOverviewConfig,
  } = useProcessOverview();

  const stilovi = {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '46px',
      backgroundColor: '#0a0a0a',
      overflow: 'hidden',
      width: '50px',
    },
    outerCircle: {
      width: '30px',
      height: '30px',
      borderRadius: '50%',
      border: '3px solid #1efcf9',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
    },
    innerCircle: {
      width: '20px',
      height: '20px',
      borderRadius: '50%',
      backgroundColor: 'black',
    },
    clickedInnerCircle: {
      backgroundColor: '#1efcf9',
    },
  };

  return (
    <div
      className={`${styles.wrapper}  ${montserrat.className}`}
      data-id={'approach'}
      id={'approach'}
      ref={containerRef}
    >
      <AnimatedHeadings
        el="h1"
        className={styles.sectionTitle}
        text={t('heading')}
        repeatDelay={10000}
      />
      <AnimatedParagraphs className="text-base sm:text-lg md:text-xl">
        {t('description')}
      </AnimatedParagraphs>
      <div className={styles.container}>
        {/* <motion.p
          initial={{ opacity: 0, y: -80 }}
          animate={{ opacity: 1, y: -40 }}
          transition={{ duration: 1 }}
          style={{
            textAlign: 'center',
            color: '#1efcf9',
            fontSize: '16px',
            fontWeight: '500',
            marginBottom: '20px',
            lineHeight: '1.4',
          }}
        >
          {t('clickOnCircles')}
          <br />
          {t('toReveal')}
        </motion.p> */}
        {processOverviewConfig.map((card, i) => {
          return (
            <div
              key={card.title || `${card.title}-${i}`}
              className={styles.cardContainer}
            >
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                // animate={activeIndex === i ? { opacity: 1, y: 0 } : false}
                animate={{ opacity: 1, y: 0 }}
                // transition={
                //   activeIndex === i
                //     ? { duration: 1.5, ease: 'easeOut' }
                //     : undefined
                // }
                transition={{ duration: 1.5, ease: 'easeOut' }}
                className={`${isEven(i) ? styles.odd : styles.even} ${
                  styles.cardWrapper
                } ${activeIndex !== i ? 'opacity-0' : ''}`}
              >
                <Card className={styles.card}>
                  <CardHeader>
                    <CardDescription>{card.description}</CardDescription>
                  </CardHeader>
                </Card>
              </motion.div>

              <div className={styles.line} onClick={() => handleClick(i)}>
                <div style={stilovi.container}>
                  <motion.div
                    initial={{ opacity: 1, scale: 1 }}
                    animate={{ scale: [1, 1.2, 1], opacity: [1, 0.7, 1] }}
                    transition={{
                      duration: 2,
                      repeat: Infinity,
                      repeatType: 'reverse',
                      ease: 'easeInOut',
                    }}
                    style={{
                      ...stilovi.outerCircle,
                      boxShadow: '0 0 10px #1efcf9', // Glow effect for first circle
                    }}
                  >
                    <div
                      style={
                        activeIndex === i
                          ? stilovi.clickedInnerCircle
                          : stilovi.innerCircle
                      }
                    />
                  </motion.div>
                </div>
              </div>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                // animate={activeIndex === i ? { opacity: 1, y: 0 } : false}
                animate={{ opacity: 1, y: 0 }}
                // transition={
                //   activeIndex === i
                //     ? { duration: 1.5, ease: 'easeOut' }
                //     : undefined
                // }
                transition={{ duration: 1.5, ease: 'easeOut' }}
                className={`${isEven(i) ? styles.even : styles.odd} ${
                  styles.title
                }`}
              >
                <h1 className={activeIndex === i ? styles.titleActive : ''}>
                  {card.title}
                </h1>
              </motion.div>
            </div>
          );
        })}
        <div className={styles.line}>
          <div style={stilovi.container} />
        </div>
      </div>
    </div>
  );
};

export default ProcessOverview;
